export function replaceImg({str,width,height}) {
    str = str.replace(/(<img[^>]*>)|(<img[^>]*><\/img>)/g, function (match, capture) {
        if (match.indexOf('style') < 0) {
            // 没有style 就添加一个
            return match.replace(/<\s*img/, '<img style=""');
        } else {
            // 有style 就不做处理 直接返回
            return match
        }
    })
    str = str.replace(/<img[^>]*>/gi, function (match, capture) {
        return match.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, 'style="width:100%;height:auto;margin:0 auto; display:block;"') // 替换style
    })
    return str
}